
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import SectionControl from './section-control'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "sectioncontrol"
    }}>{`SectionControl`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "section-control-disclosure"
    }}>{`Section Control (disclosure)`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For efficiently displaying sections of content as blocks, collapsed on first view.
A control expands or collapses each block to reveal or conceal content.`}</p>
    <Playground __position={1} __code={'<SectionControl sectionTitle=\"Section title\">Section text</SectionControl>\n<SectionControl sectionTitle=\"Section title\">Section text</SectionControl>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionControl
    }} mdxType="Playground">
  <SectionControl sectionTitle='Section title' mdxType="SectionControl">Section text</SectionControl>
  <SectionControl sectionTitle='Section title' mdxType="SectionControl">Section text</SectionControl>
    </Playground>
    <hr />
    <h2 {...{
      "id": "section-control-inverse-disclosure"
    }}>{`Section Control (inverse, disclosure)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For efficiently displaying sections of content as blocks, collapsed on first view.
A control expands or collapses each block to reveal or conceal content.`}</p>
    <Playground __position={3} __code={'<SectionControl inverse sectionTitle=\"Section title\">\n  Section text\n</SectionControl>\n<SectionControl inverse sectionTitle=\"Section title\">\n  Section text\n</SectionControl>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      SectionControl
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
    <SectionControl inverse sectionTitle='Section title' mdxType="SectionControl">Section text</SectionControl>
    <SectionControl inverse sectionTitle='Section title' mdxType="SectionControl">Section text</SectionControl>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={SectionControl} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;